<template>
    <div data-test-view="reviews-cycles-edit-participants">
        <l-reviews-edit-cycles-header :id="id" :title="$t(`reviews.admin.participantsTitle`)" />

        <l-reviews-edit-participants-form :id="id" @next="next" />
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LReviewsEditCyclesHeader from "@/components/LReviewsEditCyclesHeader";
import LReviewsEditParticipantsForm from "@/components/LReviewsEditParticipantsForm";

export default {
    components: {
        LReviewsEditCyclesHeader,
        LReviewsEditParticipantsForm,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            reviewCycle: {},
        };
    },
    computed: {
        ...mapGetters({
            getCycleDetails: "reviews/cycles/details",
        }),
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                this.reviewCycle = this.getCycleDetails(this.id);
            },
        },
    },
    methods: {
        next() {
            if (this.reviewCycle.status.globalStatus === "draft") {
                this.$router.push(`/reviews/cycles/edit/${this.id}/scope`);
            } else {
                this.$router.push(`/reviews/cycles/edit/${this.id}/status`);
            }
        },
    },
};
</script>
